import React, { lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
//import through lazy loading
const Marque = lazy(() => import("../components/Marque/Marque"));
// const Header = lazy(() => import("../components/Header/index"));
const Footer = lazy(() => import("../components/Footer/Footer"));
const Navbar = lazy(() => import("../components/Navbar/Navbar"));
const BottomFooter = lazy(() =>
  import("../components/BottomFooter/BottomFooter")
);

const componentMap = {
  Home: lazy(() => import("../pages/Home/Home")),
  NotFound : lazy(() => import("../components/NotFound/NotFound")),
  AboutUs: lazy(() => import("../pages/AboutUs/AboutUs")),
  Loginwithemail_V2: lazy(() =>
    import("../pages/LoginWithEmailV2/LoginWithEmailV2")
  ),
  OrganisationalStructure: lazy(() =>
    import("../pages/OrganisationalStructure/OrganisationalStructure")
  ),
  MissionVision: lazy(() => import("../pages/MissionVision/MissionVision")),
  Infrastructure: lazy(() => import("../pages/Infrastructure/Infrastructure")),
  SlotBooking: lazy(() => import("../pages/SlotBooking/Index.jsx")),
  VenueDetails: lazy(() => import("../pages/SlotBooking/VenueDetails.jsx")),
  VenueInfraStructure: lazy(() => import("../pages/SlotBooking/VenueInfra/VenueInfra.jsx")),
  VenueInfraStructureDetails: lazy(() => import("../pages/SlotBooking/VenueInfra/VenueInfraDetails.jsx")),
  TicketDetails: lazy(() => import("../pages/SlotBooking/TicketDetails.jsx")),
  Payment: lazy(() => import("../pages/SlotBooking/Payment.jsx")),
  MyBooking: lazy(() => import("../pages/SlotBooking/Booking/MyBooking.jsx")),
  VenueBookingDetails: lazy(() => import("../pages/SlotBooking/VenueBookingDetails.jsx")),
  Etender: lazy(() => import("../pages/E-Tender/Etender")),
  WebsiteNotification: lazy(() =>
    import("../pages/WebsiteNotification/WebsiteNotification")
  ),
  Calender: lazy(() => import("../pages/Calender/index")),
  Athletes: lazy(() => import("../pages/Athletes/Athletes")),
  LatestNews: lazy(() => import("../pages/LatestNews/LatestNews")),
  LatestVideos: lazy(() => import("../pages/LatestVideos/LatestVideos")),
  NewsDetails: lazy(() => import("../pages/NewsDetails/NewsDetails")),
  Contactus: lazy(() => import("../pages/ContactUs/ContactUs")),
  PhotoGallery: lazy(() => import("../pages/PhotoGallery/PhotoGallery")),
  AthletesProfile: lazy(() =>
    import("../pages/AthletesProfile/AthletesProfile")
  ),
  RightToInfo: lazy(() => import("../pages/RightToInfo/RightToInfo")),
  Scholarship: lazy(() => import("../pages/Scholarship/Scholarship")),
  HeadtoHead: lazy(() => import("../pages/HeadtoHead/HeadtoHead")),
  ForgetPassword: lazy(() => import("../pages/ForgetPassword/ForgetPassword")),
  LoginwithOTP_V2: lazy(() => import("../pages/LoginWithOTPV2/LoginWithOTPV2")),
  Registration: lazy(() => import("../pages/Registration")),
  InsitutionInitialCard: lazy(() =>
    import("../pages/InsitutionInitialCard/InsitutionInitialCard")
  ),
  InstitutionRegistration: lazy(() =>
    import("../pages/InstitutionRegistration")
  ),
  InstitutionStatusCard: lazy(() =>
    import("../pages/InsitutionRegisterStatus/RegistrationStatusCard")
  ),
  // InstitutionStatusCard: lazy(() =>
  //   import("../pages/InsitutionRegisterStatus/RegistrationStatusCard")
  // ),
  Scheme: lazy(() => import("../pages/Scheme")),
  Schemes: lazy(() => import("../pages/Schemes/Index.jsx")),
  SchemeDetails: lazy(() => import("../pages/SchemeDetails/Index.jsx")),
  ComingSoon: lazy(() => import("../components/ComingSoonPage/ComingSoon")),
  TrialRegistration: lazy(() => import("../pages/TrialRegistration/index.jsx")),
  AdminTrialRegistration: lazy(() =>
    import("../pages/AdminTrialRegistration/index.jsx")
  ),
  // MyBookingCart: lazy(()=>import("../components/BookingCart/MyBookingCart")),
};

//Routes
// const authRoutes = [{ path: "", element: "" }];

const publicRoutes = [
  { path: "/", element: "Home" },
  { path: "/aboutUs", element: "AboutUs" },
  { path: "/login_email", element: "Loginwithemail_V2" },
  // { path: "/organisational_structure", element: "OrganisationalStructure" },
  { path: "/organisational_structure", element: "AboutUs" },
  { path: "/tender", element: "Etender", props: { id: "1" } },
  { path: "/login_otp", element: "LoginwithOTP_V2" },
  { path: "/forget_password", element: "ForgetPassword" },
  { path: "/otp-verification", element: "OTP_Verification" },
  { path: "/create-new-password", element: "CreateNewPassword" },
  { path: "/registration", element: "Registration" },
  { path: "/institution-registration", element: "InstitutionRegistration" },
  {
    path: "/institution-registration-profile",
    element: "InsitutionInitialCard",
  },
  { path: "/final-status", element: "InstitutionStatusCard" },
  { path: "/infrastructure", element: "Infrastructure" },
  // { path: "/scholarship", element: "Scholarship" },
  { path: "/scholarship", element: "AboutUs" },

  { path: "/policie", element: "Etender", props: { id: "7" } },
  { path: "/govt-circular", element: "Etender", props: { id: "8" } },
  { path: "/contact-us", element: "Contactus" },
  //  { path: "/calendar", element: "Calender" },
  { path: "/calendar", element: "Calender" },
  { path: "/tournament", element: "Calender" },
  { path: "/athletes", element: "Athletes" },
  { path: "/athletes_profile", element: "AthletesProfile" },
  { path: "/head_to_head", element: "HeadtoHead" },
  { path: "/latest-news", element: "LatestNews" },
  { path: "/latest-news/:id", element: "NewsDetails" },
  { path: "/news-details", element: "NewsDetails" },
  { path: "/latest-videos", element: "LatestVideos" },
  { path: "/photoGallery", element: "PhotoGallery" },
  { path: "/right-to-information", element: "RightToInfo" },
  // { path: "/mission_vision", element: "MissionVision" },
  { path: "/mission_vision", element: "AboutUs" },

  { path: "/website-notification", element: "WebsiteNotification" },

  { path: "/venue-list", element: "SlotBooking" },
  { path: "/venue-details", element: "VenueDetails" },
  { path : "/venue-infra", element: "VenueInfraStructure"},
  { path : "/venue-infra-details", element: "VenueInfraStructureDetails"},
  { path: "/venue-slot-booking-status", element: "TicketDetails" },
  { path: "/venue-slot-booking-details", element: "Payment" },
  { path: "/venue-my-booking", element: "MyBooking" },
  { path: "/venue-booking-details", element: "VenueBookingDetails" },
  { path: "/scheme", element: "Scheme" },
  { path: "/schemes", element: "Schemes", props: { id: "13" } },
  { path: "/scheme/:id", element: "SchemeDetails" },
  { path: "/trial-registration", element: "TrialRegistration" },
  { path: "/admin-registration-form", element: "AdminTrialRegistration" },
  { path: "/*", element: "NotFound" },
  { path: "/comingsoon", element: "ComingSoon" },
  { path: "/not-found", element: "NotFound" },
  // { path: "/mybooking-cart", element: "MyBookingCart" },
];

// Routes where Marque and Header should be hidden
const hideComponentsOnRoutes = [
  "/login_otp",
  "/login_email",
  "/registration",
  "/register_as_support_staff",
  "/register_as_athlete",
  "/register_as_other",
  "/forget-password",
  "/otp-verification",
  "/individual",
  "/create-new-password",
  "/final-submit_individual_registration",
  "/auth_registration",
  "/register_as",
  "/final-status",
  "/trial-registration",
  "/admin-registration-form",
];
const hideFooterRoutes = [...hideComponentsOnRoutes, "/infrastructure"];

export default function MainRoutesComp() {
  const location = useLocation();
  const currentPath = location.pathname;
  const hideHeaderAndMarque = hideComponentsOnRoutes.includes(
    location.pathname
  );
  const hideFooter = hideFooterRoutes.includes(currentPath);
  return (
    <>
      <div>
        {!hideHeaderAndMarque && (
          <div>
            {/* <div className="linear-gradient"></div> */}
            <Marque />
            {/* <Header /> */}
            <Navbar />
          </div>
        )}
      </div>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {publicRoutes.map((route, index) => {
            const Component = componentMap[route.element];
            return Component ? (
              <Route
                key={index}
                path={route.path}
                element={<Component {...(route.props || {})} />}
              />
            ) : null;
          })}
        </Routes>
      </Suspense>

      {!hideFooter && (
        <>
          <Footer />
          <BottomFooter />
        </>
      )}
    </>
  );
}
